import React from 'react';

import { createRoot } from 'react-dom/client';

if (import.meta.env.VITE_OVERRIDE_ENV) {
  window.__OVERRIDE_ENV__ = import.meta.env.VITE_OVERRIDE_ENV;
}

if (import.meta.env.VITE_OVERRIDE_DOMAIN) {
  window.__OVERRIDE_DOMAIN__ = import.meta.env.VITE_OVERRIDE_DOMAIN;
}

if (import.meta.env.VITE_OVERRIDE_HOST) {
  window.__OVERRIDE_HOST__ = import.meta.env.VITE_OVERRIDE_HOST;
}

if (import.meta.env.VITE_OVERRIDE_X_Forwarded_Host) {
  window.__OVERRIDE_X_Forwarded_Host__ =
    import.meta.env.VITE_OVERRIDE_X_Forwarded_Host;
}

import { RelayEnvironment } from './RelayEnvironment';
import AppLoader from './AppLoader';
import App from './App';
import { Toaster } from 'shared-ui';

const container = document.getElementById('root');
if (container === null) {
  throw Error('No Root Element To Render React');
}
const root = createRoot(container);

root.render(
  <RelayEnvironment>
    <AppLoader>
      <Toaster />
      <App />
    </AppLoader>
  </RelayEnvironment>,
);
